<template>
  <div class="common">
    <a-tabs type="card" v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name">
        <keep-alive v-if="tabCur == item.key">
          <component :is="item.comp" :tabType="item.key" :gldStCds="item.gldStCds"
            :goldStatusOptions="item.goldStatusOptions" :rcPty="item.rcPty" :isGldPay="item.isGldPay"
            :isGldLend="item.isGldLend" :pypt="item.pypt" :isGldEx="item.isGldEx" :exDayEnd="item.exDayEnd"
            formType="seller" :totalName="item.totalName" :totalProp="item.totalProp" :columnsSource="item.columns"
            :fromTypeRouter="item.fromType" :formSource="item.form" :pageType="item.pageType"
            fromPath='inquiry/goldenbill/seller'></component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import goldPage from "@/components/gold-page/gold-page"
const systemDate = window.sessionStorage.getItem('systemDate') || new Date();
export default {
  components: {
    goldPage
  },
  name: "goldenbill",
  data() {
    return {
      tabData: [
        {
          name: "已签收",
          key: "sellerSigned",
          comp: goldPage,
          pageType: "GldQuery",
          fromType: "5",
          gldStCds: "1,6",
          rcPty: this.$store.getters['home/getUserObj'].cstIds.join(','),
          goldStatusOptions: [{ name: "已签收", value: 1 }, { name: "已结清", value: 6 }],
          totalName: "祺信余额",
          totalProp: "gldBal",
          columns: ["签收日期", "祺信编号", "开立方", "担保方", "流转方", "祺信余额(元)", "到期日期", "剩余天数", "变更状态", "有无发票", "操作"],
          form: ["签收日期", "祺信编号", "到期日期", "变更状态", "开立方", "流转方", "祺信状态"]
        },
        {
          name: "已支付",
          key: "sellerPaid",
          comp: goldPage,
          pageType: "GldQuery",
          fromType: "1",
          gldStCds: "1,6",
          isGldPay: 'Y',
          pypt: this.$store.getters['home/getUserObj'].cstIds.join(','),
          goldStatusOptions: [{ name: "已签收", value: 1 }, { name: "已结清", value: 6 }],
          columns: ["支付日期", "祺信编号", "开立方", "担保方", "接收方", "祺信面额(元)", "到期日期", "上级祺信", "变更状态", "有无发票", "操作"],
          form: ["支付日期", "祺信编号", "接收方", "到期日期", "上级祺信", "变更状态", "开立方"]
        },
        {
          name: "已融资",
          key: "sellerFinanced",
          comp: goldPage,
          pageType: "GldQuery",
          fromType: "1",
          // fnsStCd: 12,
          gldStCds: "1,6",
          pypt: this.$store.getters['home/getUserObj'].cstIds.join(','),
          isGldLend: "Y",
          goldStatusOptions: [{ name: "已签收", value: 1 }, { name: "已结清", value: 6 }],
          columns: ["申请日期", "祺信编号", "开立方", "担保方", "接收方", "祺信面额(元)", "到期日期", "上级祺信", "变更状态", "操作"],
          form: ["申请日期", "祺信编号", "接收方", "到期日期", "上级祺信", "变更状态", "开立方"]
        },
        {
          name: "已到期",
          key: "sellerExpired",
          comp: goldPage,
          pageType: "GldQuery",
          fromType: "5",
          gldStCds: "1,6",
          rcPty: this.$store.getters['home/getUserObj'].cstIds.join(','),
          isGldEx: 'Y',
          exDayEnd: this.utils.dateFormat(new Date(systemDate), 'yyyy-MM-dd', null, 1),
          goldStatusOptions: [{ name: "已签收", value: 1 }, { name: "已结清", value: 6 }],
          totalName: "待收余额",
          columns: ["到期日期", "祺信编号", "开立方", "担保方", "流转方", "祺信面额(元)", "待收余额(元)", "回款金额(元)", "变更状态", "是否逾期", "有无发票", "操作"],
          form: ["祺信编号", "到期日期", "变更状态", "是否逾期", "开立方", "流转方"]
        }
      ],
      tabCur: "sellerSigned"
    }
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj"

    })
  },
  created() {
  },
  mounted() {

  },
  methods: {


  },
  activated() {

  },
};
</script>
<style scoped lang="less">
.common {
  /deep/ .ant-tabs-tab-active {
    border-bottom: 1px solid #e8e8e8 !important;
  }

  /deep/ .ant-tabs-bar {
    border-bottom: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/inquiry/seller.vue